<template>
  <!-- 提交服务相关 -->
  <div class="mar-top custom-steps room-control" v-if="basicInfo.subject">
    <div v-if="dftDemandOptions.length">
      <van-cell-group :title="roomTitle">
        <van-cell :title="basicInfo.roomNum"></van-cell>
      </van-cell-group>
      <van-cell-group title="当前会议">
        <van-cell :title="basicInfo.subject"></van-cell>
      </van-cell-group>
      <van-cell-group :title="'快捷需求'+(serviceSumPrice? `（共￥${serviceSumPrice.toFixed(2)}）` : '')">
        <van-cell v-for="(item,idx) in dftDemandOptions" :key="idx">
          <template #title>
            <span>{{item.name}}</span>
            <span v-if="item.price">（￥{{item.price.toFixed(2)}}/{{item.unit || '份'}} )</span>
          </template>
          <template>
            <van-stepper v-model="qkDms[item.name]" min="0" :default-value="0"></van-stepper>
          </template>
        </van-cell>
      </van-cell-group>
      <van-cell-group title="其它">
        <van-field v-model="specificContent" placeholder="请填写服务具体需求"
                   rows="2" autosize type="textarea" maxlength="30"></van-field>
      </van-cell-group>

      <div class="mar-hor fixed-btn">
        <van-button block @click="submitService">提交服务需求</van-button>
      </div>
    </div>
    <div v-else>
      <empty-notice :desc="'暂不支持提供服务'"></empty-notice>
    </div>
  </div>
  <div v-else class="bg-white mar-top pad-ver">
    <van-skeleton title :row="10"></van-skeleton>
  </div>
</template>

<script>
  import {meeting, service} from "../../../../server"
  import {getStorage, StorageKey} from "../../../../tools/storage";
  import {assembleDemandOptions, checkRespCorrect, checkShowPermit} from "../../../../tools/utils";
  import {messageHdl, msgCode} from "../../../../tools/messageHdlr";
  import routerMeta from "../../router/routerMeta";

  export default {
    data() {
      return {
        userId: getStorage(StorageKey.userId),
        mid: "",
        mDoc: {},
        qkDms: {},
        specificContent: "",
      }
    },
    computed: {
      roomTitle() {
        return this.$store.state.formTitles.meetingRoom
      },
      basicInfo() {
        const {subject, meetingRooms = []} = this.mDoc;
        const [firstRoom] = meetingRooms;
        return {
          subject,
          roomId: firstRoom && firstRoom.roomId,
          roomNum: firstRoom && firstRoom.roomNum
        }
      },
      dftDemandOptions() {
        const {meetingRooms, insideParticipant = [], customerGrade} = this.mDoc;
        return checkShowPermit(this.$store.state.permissionList || [], this.permitsMap.serviceCall) && assembleDemandOptions({
          reserveDoc: {
            room: (meetingRooms || [])[0] || {},
            customerGrade: customerGrade || 0,
            insideParticipant: insideParticipant,
          },
          serviceSetting: this.$store.state.sysConfig.serviceSetting || {},
        }) || []
      },
      serviceSumPrice() {
        return Object.keys(this.qkDms).reduce((sum, k) => {
          const dm = this.dftDemandOptions.find(e => e.name === k) || {};
          return sum + (this.qkDms[k] && dm.price ? this.qkDms[k] * dm.price : 0)
        }, 0)
      },
    },
    mounted() {
      this.mid = this.$route.params.mid;
      this.initMDoc()
    },
    methods: {
      initMDoc() {
        UILoader.load();
        // 查询会议信息
        meeting.queryDetail(this, {queryFilter: {selfCursor: this.mid}}).then(({searchMeeting: data = {}}) => {
          UILoader.unload();
          this.beforeQuery && (this.beforeQuery = false);
          const [edge] = (data.meetingEdges || []);
          if (edge && edge.cursor === this.mid && edge.meeting) {
            this.mDoc = edge.meeting;
          } else {
            vtToast("会议不存在")
          }
        }).catch(err => {
          UILoader.unload();
          // console.log(err);
          vtToast(err.message)
        });
      },
      // 提交服务单
      submitService() {
        const data = {
          meetingRoomId: this.basicInfo.roomId,
          meetingId: this.mid,
          quickDemands: Object.keys(this.qkDms).filter(k => this.qkDms[k] > 0).map(k => {
            const dm = this.dftDemandOptions.find(e => e.name === k) || {};
            return {
              type: k,
              price: dm.price,
              unit: dm.unit,
              amount: this.qkDms[k]
            }
          }),
          specificContent: this.specificContent
        };
        if (data.quickDemands.length || data.specificContent) {
          service.callService(this, {req: data}).then(({callService: resp = {}}) => {
            if (checkRespCorrect(resp, "提交失败")) {
              messageHdl({code: msgCode.SUCCESS, msg: "提交成功"});
              const mtBackRoute = getStorage(StorageKey.mtBackRoute);
              if (mtBackRoute) {
                this.$router.push({path: mtBackRoute});
              } else {
                this.$router.push({name: routerMeta.meetingDetail.name, params: this.$route.params});
              }
            }
          }).catch(err => {
            messageHdl({msg: err.message});
          })
        } else {
          vtToast("请先填写需求")
        }
      }
    }
  }
</script>

<style scoped>
</style>
